var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 19.3594V22.9994C28 25.7594 25.76 28.9994 23 28.9994H9C6.24 28.9994 4 25.7594 4 22.9994V19.3594C4.852 19.953 5.8256 20.3493 6.85 20.5194L11.28 21.2594C11.5203 21.7786 11.904 22.2182 12.3859 22.5265C12.8679 22.8348 13.4279 22.9989 14 22.9994H18C18.5721 22.9989 19.1321 22.8348 19.6141 22.5265C20.096 22.2182 20.4797 21.7786 20.72 21.2594L25.15 20.5194C26.1744 20.3493 27.148 19.953 28 19.3594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7H21V6C20.9977 5.20508 20.6808 4.4434 20.1187 3.8813C19.5566 3.31921 18.7949 3.00237 18 3H14C13.2051 3.00237 12.4434 3.31921 11.8813 3.8813C11.3192 4.4434 11.0024 5.20508 11 6V7H8.00003C5.24003 7 3.00003 10.24 3.00003 13V13.61C2.99613 14.7947 3.4149 15.942 4.18108 16.8457C4.94726 17.7493 6.01061 18.3501 7.18003 18.54L11 19.18V18C11.0024 17.2051 11.3192 16.4434 11.8813 15.8813C12.4434 15.3192 13.2051 15.0024 14 15H18C18.7949 15.0024 19.5566 15.3192 20.1187 15.8813C20.6808 16.4434 20.9977 17.2051 21 18V19.18L24.82 18.54C25.9894 18.3501 27.0528 17.7493 27.819 16.8457C28.5852 15.942 29.0039 14.7947 29 13.61V13C29 10.24 26.76 7 24 7ZM13 7V6C13 5.73478 13.1054 5.48043 13.2929 5.29289C13.4805 5.10536 13.7348 5 14 5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8947 5.48043 19 5.73478 19 6V7H13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H14C13.4477 17 13 17.4477 13 18V20C13 20.5523 13.4477 21 14 21H18C18.5523 21 19 20.5523 19 20V18C19 17.4477 18.5523 17 18 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvBag);
export default __webpack_public_path__ + "static/media/EvBag.3d9617804f735ecc4be4760f1715f004.svg";
export { ForwardRef as ReactComponent };